import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Apis from '../../api';
import { HEADERMENU_PATH } from '../../routes/RoutesURL';
import { RootState } from '../../store/rootReducer';
import HSButton from '../common/Button';
import MessageActions from '../message/redux/actions';

const ResendActivationEmail: React.FC = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const email = useSelector((state: RootState) => state.user.user?.email);

    const [loader, setLoader] = useState(false);

    const ResendActivationEmail = () => {
        if (email) {
            setLoader(true);
            Apis.resendActivationEmail({
                email: email && email.trim(),
            })
                .then(() => {
                    dispatch(
                        MessageActions.showMessage({
                            error: false,
                            text: 'Account Activation email sent successfully',
                        }),
                    );
                })
                .catch((err) => {
                    dispatch(MessageActions.showMessage({ error: true, text: String(err) }));
                })
                .finally(() => {
                    setLoader(false);
                });
        } else {
            navigate(HEADERMENU_PATH.login);
        }
    };

    return (
        <div className="h-full flex justify-center items-center">
            <div className="w-full" id="login">
                <div className="text-base text-center">
                    <p>Your account is still pending activation.</p>
                    <p>
                        Please activate your account by following instructions in the Account Activation email that was
                        sent to you earlier.
                    </p>
                    <p>
                        If you haven't received this email, please click below to resend (sometimes system generated
                        emails could go into Spam instead of Inbox, so please check your Spam email folder, in case you
                        don't receive this email in your Inbox, even after resend)
                    </p>
                </div>
                <div className="flex justify-center items-center py-4 mt-4 flex-col">
                    <HSButton title="Send Activation Email" loading={loader} onClick={ResendActivationEmail} />
                    <HSButton
                        title="Return to Log in"
                        type="link"
                        onClick={() => navigate(HEADERMENU_PATH.login)}
                        className="mt-2 text-base text-black hover:text-black underline underline_b"
                    />
                </div>
            </div>
        </div>
    );
};

export default ResendActivationEmail;
